export const EMPTY_FORM = {
  id: null,
  title: '',
  kickoffLocal: '',
  homeTeam: '',
  awayTeam: '',
  venue: '',
  city: '',
  enableResult: true,
  enableYellowCards: false,
  enableRedCards: false,
  enableCorners: false,
  homeScore: '',
  awayScore: '',
  yellowCards: '',
  redCards: '',
  corners: '',
}

export const CATEGORY_KEYS = [
  { key: 'enableResult', label: 'Resultat (mål)' },
  { key: 'enableYellowCards', label: 'Antal gule kort' },
  { key: 'enableRedCards', label: 'Antal røde kort' },
  { key: 'enableCorners', label: 'Antal hjørnespark' },
]
